import {jwtDecode} from 'jwt-decode';
import Cookies from 'universal-cookie';

export default class Auth {

   constructor() {
      this.logout = this.logout.bind(this);
      this.hasPermission = this.hasPermission.bind(this);
      this.hasPermissions = this.hasPermissions.bind(this);
   }

   isAuthenticated() {
      try {
         let expiresAt = this.getClaim("exp") * 1000;
         if (process.env.NODE_ENV !== "production")
            return true;
         return new Date().getTime() < expiresAt;
      }
      catch {
         return false;
      }
   }

   logout() {
      // Clear access token and ID token from cookies
      const cookies = new Cookies(null, {path: '/'});
      cookies.remove('access_token', { path: '/' });
      cookies.remove('id_token', { path: '/' });
      cookies.remove('expires_at', { path: '/' });
      // navigate to the home route
      window.location.assign(`${window.location.protocol}//${window.location.host}/logout`);
   }

   // Returns encoded access_token
   getAccessToken() {
      const cookies = new Cookies();
      const accessToken = cookies.get('access_token');
      if (!accessToken) {
         // navigate to the home route
         // window.location.assign(`${window.location.protocol}//${window.location.host}/login`);
         return 'access_token_not_present';
      }

      return accessToken;
   }

   // Returns decoded access_token
   getDecodedAccessToken() {
      let accessToken = this.getAccessToken();

      if (accessToken === 'access_token_not_present') {
         return 'access_token_not_present';
      }

      return jwtDecode(accessToken);
   }

   getIdToken() {
      const cookies = new Cookies();
      const idToken = cookies.get('id_token');
      if (!idToken) {
         // navigate to the home route
         // window.location.assign(`${window.location.protocol}//${window.location.host}/login`);
         return 'id_token_not_present';
      }
      return idToken;
   }

   getClaim(name) {
      const decodedAccessToken = this.getDecodedAccessToken();
      if (name in decodedAccessToken) {
         return decodedAccessToken[name];
      }
   }

   hasPermission(permission) {
      const permissions = this.getClaim('hydros_permissions');
      return permissions && permissions.includes(permission);
   }

   hasPermissions(reqPermissions) {
      return reqPermissions.every(this.hasPermission);
   }

   isSuperUser() {
      return this.getClaim('hydros_is_superuser');
   }
}
